'use client'
import {
  Paper_default
} from "./chunk-GNKSIG7J.mjs";
import {
  ImageWithPlaceholder_default
} from "./chunk-XIISRR6P.mjs";
import {
  Typography_default
} from "./chunk-QNSUZHUC.mjs";
import {
  Button_default
} from "./chunk-5TLHZ4PW.mjs";

// src/Brackets/Brackets.tsx
import { useLayoutEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import { useRouter } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var Brackets = ({ groups, className, image }) => {
  const { dir } = useRouter();
  const bracketRef = useRef(null);
  const bracketContainerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  useLayoutEffect(() => {
    if (!bracketContainerRef.current || !bracketRef.current) return;
    const containerWidth = bracketContainerRef.current.getBoundingClientRect().width;
    const bracketWidth = bracketRef.current.getBoundingClientRect().width;
    const height = bracketContainerRef.current.getBoundingClientRect().height;
    setDimensions({
      width: containerWidth - bracketWidth + 8,
      height
    });
  }, [groups]);
  if (!groups || groups.length === 0) return null;
  return /* @__PURE__ */ jsx("section", { className: twMerge("hide-scrollbar gap-x-L flex w-full overflow-auto", className), children: groups.map((group, groupIndex) => {
    const nextGroup = groups[groupIndex + 1];
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "last:me-L flex w-full min-w-80 flex-1 flex-col justify-between sm:min-w-[450px]",
        ref: bracketContainerRef,
        children: [
          /* @__PURE__ */ jsx(Typography_default, { variant: "label-M", className: "my-L text-lg font-semibold", children: group.name }),
          /* @__PURE__ */ jsx("div", { className: "flex h-full flex-col justify-around gap-6", children: group.items.map((item, i) => {
            const isEven = i % 2 === 0;
            const nextMatchExists = nextGroup && nextGroup.items[Math.floor(i / 2)] !== void 0;
            const arrowHeight = dimensions.height / (group.items.length * 2);
            const hasScore = item.teams.some((team) => team.score !== void 0);
            return /* @__PURE__ */ jsxs(
              "div",
              {
                className: "relative w-full min-w-80 sm:min-w-[450px]",
                ref: bracketRef,
                children: [
                  image && groupIndex === groups.length - 1 && /* @__PURE__ */ jsx(
                    ImageWithPlaceholder_default,
                    {
                      src: image,
                      className: "absolute left-1/2 top-0 w-32 -translate-x-1/2 -translate-y-[105%] object-cover"
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    Paper_default,
                    {
                      surface: "level-1",
                      className: "!rounded-S w-full overflow-hidden border-none !p-0",
                      children: [
                        nextMatchExists && /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: "bg-body-level-2 absolute top-1/2 h-0.5",
                            style: {
                              width: `${dimensions.width}px`,
                              right: dir === "ltr" ? `-${dimensions.width}px` : void 0,
                              left: dir === "rtl" ? `-${dimensions.width}px` : void 0
                            },
                            children: /* @__PURE__ */ jsx(
                              "div",
                              {
                                className: "bg-body-level-2 absolute w-0.5 rounded-e-full ltr:left-full rtl:right-full",
                                style: {
                                  top: isEven ? "0" : `-${arrowHeight}px`,
                                  height: `${arrowHeight + 2}px`
                                },
                                children: isEven && /* @__PURE__ */ jsx("div", { className: "bg-body-level-2 absolute top-full h-0.5 w-4 ltr:left-0 rtl:right-0" })
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ jsxs("div", { className: "p-L gap-L flex items-end justify-between", children: [
                          /* @__PURE__ */ jsxs("div", { className: "space-y-M", children: [
                            /* @__PURE__ */ jsxs("div", { className: "space-y-XXS", children: [
                              item.title && /* @__PURE__ */ jsx(Typography_default, { variant: "label-S", children: item.title }),
                              item.subtitle && /* @__PURE__ */ jsx(Typography_default, { variant: "body-S", color: "text-secondary", children: item.subtitle })
                            ] }),
                            item.teams.map((team, idx) => /* @__PURE__ */ jsxs("div", { className: "gap-XS flex items-center", children: [
                              /* @__PURE__ */ jsx(
                                ImageWithPlaceholder_default,
                                {
                                  src: team.icon,
                                  alt: team.name,
                                  className: "h-6 w-6 rounded-full object-cover"
                                }
                              ),
                              /* @__PURE__ */ jsx(Typography_default, { variant: "label-M", children: team.name })
                            ] }, idx))
                          ] }),
                          !hasScore ? /* @__PURE__ */ jsx("div", { className: "flex w-full min-w-fit flex-1 shrink-0 justify-end", children: item.button }) : /* @__PURE__ */ jsx("div", { className: "space-y-M text-end", children: item.teams.map((team, idx) => /* @__PURE__ */ jsx(Typography_default, { variant: "body-M", children: team.score }, idx)) })
                        ] })
                      ]
                    }
                  )
                ]
              },
              item.id
            );
          }) })
        ]
      },
      group.name
    );
  }) });
};
var Brackets_default = Brackets;

// src/Brackets/BracketsV2.tsx
import { useCallback, useEffect, useLayoutEffect as useLayoutEffect2, useMemo, useRef as useRef2, useState as useState2 } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { twMerge as twMerge2 } from "tailwind-merge";
import { ChevronIcon } from "@wbk/svg";
import { useRouter as useRouter2, useTranslation } from "@wbk/config";
import { formatDate } from "@wbk/utils";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var round = (n) => Math.round(n * 10) / 10;
var buildPath = (sx, sy, ex, ey) => {
  if (Math.abs(sy - ey) < 0.5) {
    return `M ${round(sx)} ${round(sy)} L ${round(ex)} ${round(ey)}`;
  }
  const dirX = Math.sign(ex - sx) || 1;
  const dirY = Math.sign(ey - sy) || 1;
  const midX = (sx + ex) / 2;
  const r = Math.max(0, Math.min(12, Math.abs(midX - sx), Math.abs(ey - sy) / 2));
  return [
    `M ${round(sx)} ${round(sy)}`,
    `H ${round(midX - dirX * r)}`,
    `Q ${round(midX)} ${round(sy)} ${round(midX)} ${round(sy + dirY * r)}`,
    `V ${round(ey - dirY * r)}`,
    `Q ${round(midX)} ${round(ey)} ${round(midX + dirX * r)} ${round(ey)}`,
    `H ${round(ex)}`
  ].join(" ");
};
var BracketsV2 = ({ groups, className, image, showArrows }) => {
  const { t } = useTranslation(["ui_common"]);
  const { locale } = useRouter2();
  const dir = (locale == null ? void 0 : locale.startsWith("ar")) ? "rtl" : "ltr";
  const emblaOptions = useMemo(
    () => ({
      align: "start",
      direction: dir,
      containScroll: "trimSnaps",
      dragFree: false,
      slides: "[data-bracket-slide]"
    }),
    [dir]
  );
  const [emblaRef, emblaApi] = useEmblaCarousel(emblaOptions);
  const containerRef = useRef2(null);
  const cardRefs = useRef2(/* @__PURE__ */ new Map());
  const rafRef = useRef2(null);
  const [segments, setSegments] = useState2([]);
  const [dims, setDims] = useState2({ width: 0, height: 0 });
  const [activeKey, setActiveKey] = useState2(null);
  const [canPrev, setCanPrev] = useState2(false);
  const [canNext, setCanNext] = useState2(false);
  const setCardRef = useCallback(
    (key) => (el) => {
      if (el) cardRefs.current.set(key, el);
      else cardRefs.current.delete(key);
    },
    []
  );
  const measure = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    const cRect = container.getBoundingClientRect();
    const segs = [];
    for (let g = 0; g < groups.length - 1; g++) {
      const next = groups[g + 1];
      groups[g].items.forEach((_item, i) => {
        const ti = Math.floor(i / 2);
        if (!next.items[ti]) return;
        const feeder = cardRefs.current.get(`${g}:${i}`);
        const target = cardRefs.current.get(`${g + 1}:${ti}`);
        if (!feeder || !target) return;
        const f = feeder.getBoundingClientRect();
        const t2 = target.getBoundingClientRect();
        const sy = f.top + f.height / 2 - cRect.top;
        const ty = t2.top + t2.height / 2 - cRect.top;
        const sx = (dir === "rtl" ? f.left : f.right) - cRect.left;
        const ex = (dir === "rtl" ? t2.right : t2.left) - cRect.left;
        segs.push({
          key: `${g}:${i}->${ti}`,
          d: buildPath(sx, sy, ex, ty),
          feederKey: `${g}:${i}`,
          targetKey: `${g + 1}:${ti}`,
          groupIndex: g
        });
      });
    }
    setSegments(segs);
    setDims({ width: cRect.width, height: cRect.height });
  }, [groups, dir]);
  const scheduleMeasure = useCallback(() => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(measure);
  }, [measure]);
  useLayoutEffect2(() => {
    measure();
  }, [measure]);
  useEffect(() => {
    var _a;
    const container = containerRef.current;
    if (!container) return;
    let observer;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(scheduleMeasure);
      observer.observe(container);
    }
    (_a = document.fonts) == null ? void 0 : _a.ready.then(scheduleMeasure).catch(() => void 0);
    return () => {
      observer == null ? void 0 : observer.disconnect();
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [scheduleMeasure]);
  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => {
      setCanPrev(emblaApi.canScrollPrev());
      setCanNext(emblaApi.canScrollNext());
    };
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("reInit", measure);
    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
      emblaApi.off("reInit", measure);
    };
  }, [emblaApi, measure]);
  if (!groups || groups.length === 0) return null;
  const hasArrows = !!showArrows && groups.length > 1;
  return /* @__PURE__ */ jsxs2("section", { className: twMerge2("relative w-full", className), children: [
    hasArrows && (canPrev || canNext) && /* @__PURE__ */ jsxs2("div", { className: "gap-XS flex justify-end pb-4", children: [
      /* @__PURE__ */ jsx2(
        Button_default,
        {
          shape: "outlined",
          theme: "action",
          className: "rounded-S text-body-light border-body-light flex h-9 w-9 items-center justify-center border p-0 disabled:cursor-not-allowed disabled:opacity-50",
          onClick: () => emblaApi == null ? void 0 : emblaApi.scrollPrev(),
          disabled: !canPrev,
          "aria-label": "Previous round",
          children: /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-3 w-3 ltr:rotate-180" })
        }
      ),
      /* @__PURE__ */ jsx2(
        Button_default,
        {
          shape: "outlined",
          theme: "action",
          className: "rounded-S text-body-light border-body-light flex h-9 w-9 items-center justify-center border p-0 disabled:cursor-not-allowed disabled:opacity-50",
          onClick: () => emblaApi == null ? void 0 : emblaApi.scrollNext(),
          disabled: !canNext,
          "aria-label": "Next round",
          children: /* @__PURE__ */ jsx2(ChevronIcon, { className: "h-3 w-3 rtl:rotate-180" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx2("div", { className: "hide-scrollbar overflow-hidden", ref: emblaRef, children: /* @__PURE__ */ jsxs2("div", { ref: containerRef, className: "relative flex w-full", children: [
      groups.map((group, groupIndex) => {
        const isFinal = groupIndex === groups.length - 1;
        return /* @__PURE__ */ jsx2(
          "div",
          {
            "data-bracket-slide": true,
            className: twMerge2(
              "relative z-10 w-[86vw] flex-none pe-10 sm:w-[400px]",
              isFinal && "pe-0"
            ),
            children: /* @__PURE__ */ jsxs2("div", { className: "flex h-full flex-col", children: [
              /* @__PURE__ */ jsxs2("div", { className: "pb-10", children: [
                /* @__PURE__ */ jsx2(Paper_default, { border: false, className: "!rounded-M bg-opacity-15", children: /* @__PURE__ */ jsx2(Typography_default, { variant: "label-L", className: "truncate", color: "secondary", children: group.name }) }),
                (group.startDate || group.endDate) && /* @__PURE__ */ jsx2(Typography_default, { variant: "label-M", className: "p-S text-body-light", children: group.startDate && group.endDate && group.startDate !== group.endDate ? `${formatDate(group.startDate, locale, { day: "numeric", month: "short" })} - ${formatDate(group.endDate, locale, { day: "numeric", month: "short" })}` : formatDate(group.startDate || group.endDate, locale, {
                  day: "numeric",
                  month: "short"
                }) })
              ] }),
              /* @__PURE__ */ jsx2("div", { className: "flex h-full flex-col justify-around gap-6 p-1", children: group.items.map((item, i) => {
                const cardKey = `${groupIndex}:${i}`;
                const hasScore = item.teams.some((team) => team.score !== void 0);
                const headerLabel = hasScore ? t("ui_common:brackets.full_time") : item.startDateTime ? `${formatDate(item.startDateTime, locale, {
                  weekday: "short",
                  day: "numeric",
                  month: "short"
                })} \xB7 ${formatDate(item.startDateTime, locale, {
                  hour: "2-digit",
                  minute: "2-digit"
                })}` : t("ui_common:brackets.tbd");
                return /* @__PURE__ */ jsxs2(
                  "div",
                  {
                    ref: setCardRef(cardKey),
                    onMouseEnter: () => setActiveKey(cardKey),
                    onMouseLeave: () => setActiveKey(null),
                    onFocus: () => setActiveKey(cardKey),
                    onBlur: () => setActiveKey(null),
                    className: twMerge2(
                      "focus-within:ring-primary rounded-M relative w-full transition-all duration-200 focus-within:ring-2",
                      activeKey === cardKey && "ring-primary ring-4"
                    ),
                    children: [
                      image && isFinal && i === 0 && /* @__PURE__ */ jsxs2("div", { className: "absolute left-1/2 top-0 -translate-x-1/2 -translate-y-[105%]", children: [
                        /* @__PURE__ */ jsx2("div", { className: "bg-primary/50 absolute inset-0 rounded-full blur-xl" }),
                        /* @__PURE__ */ jsx2(
                          ImageWithPlaceholder_default,
                          {
                            src: image,
                            className: "relative w-24 object-contain"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxs2(
                        Paper_default,
                        {
                          className: "!rounded-M flex w-full flex-col overflow-hidden !p-0",
                          border: false,
                          children: [
                            /* @__PURE__ */ jsx2("div", { className: "space-y-XXS px-M bg-primary/20 py-2", children: /* @__PURE__ */ jsx2(
                              Typography_default,
                              {
                                variant: "label-XS",
                                color: hasScore ? "text-primary" : "text-secondary",
                                children: headerLabel
                              }
                            ) }),
                            /* @__PURE__ */ jsxs2("div", { className: "gap-L p-M flex items-end justify-between", children: [
                              /* @__PURE__ */ jsx2("div", { className: "space-y-M min-w-0 grow", children: item.teams.map((team, idx) => /* @__PURE__ */ jsxs2("div", { className: "gap-XS flex items-center", children: [
                                /* @__PURE__ */ jsx2(
                                  ImageWithPlaceholder_default,
                                  {
                                    src: team.icon,
                                    alt: team.name,
                                    className: "h-6 w-6 shrink-0 object-contain"
                                  }
                                ),
                                /* @__PURE__ */ jsx2(Typography_default, { variant: "label-M", className: "truncate", children: team.name })
                              ] }, idx)) }),
                              !hasScore ? /* @__PURE__ */ jsx2("div", { className: "flex min-w-fit shrink-0 justify-end", children: item.button }) : /* @__PURE__ */ jsx2("div", { className: "space-y-M shrink-0 text-end", children: item.teams.map((team, idx) => {
                                var _a;
                                const otherScore = (_a = item.teams[idx === 0 ? 1 : 0]) == null ? void 0 : _a.score;
                                const isWinner = team.score !== void 0 && otherScore !== void 0 && team.score > otherScore;
                                return /* @__PURE__ */ jsx2(
                                  "div",
                                  {
                                    className: twMerge2(
                                      "border-paper-level-1 flex h-6 w-6 items-center justify-center rounded border text-center",
                                      isWinner && "border-transparent bg-green-500 text-white"
                                    ),
                                    children: /* @__PURE__ */ jsx2(Typography_default, { variant: "body-S", children: team.score })
                                  },
                                  idx
                                );
                              }) })
                            ] })
                          ]
                        }
                      )
                    ]
                  },
                  item.id
                );
              }) })
            ] })
          },
          group.name
        );
      }),
      groups.length > 1 && /* @__PURE__ */ jsx2(
        "svg",
        {
          "aria-hidden": true,
          className: "pointer-events-none absolute inset-0 h-full w-full overflow-visible",
          viewBox: `0 0 ${dims.width} ${dims.height}`,
          preserveAspectRatio: "none",
          fill: "none",
          children: segments.map((s) => {
            const active = activeKey === s.feederKey || activeKey === s.targetKey;
            return /* @__PURE__ */ jsx2(
              "path",
              {
                d: s.d,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "transition-all duration-200 motion-reduce:transition-none",
                style: {
                  stroke: active ? "hsl(var(--color-primary-500))" : "hsl(var(--bg-body-level-2))",
                  strokeWidth: active ? 3 : 2
                },
                opacity: active ? 1 : 0.5
              },
              s.key
            );
          })
        }
      )
    ] }) })
  ] });
};
var BracketsV2_default = BracketsV2;

// src/Brackets/BracketsLoader.tsx
import { twMerge as twMerge3 } from "tailwind-merge";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var BracketsLoader = ({ className }) => {
  return /* @__PURE__ */ jsx3("section", { className: twMerge3("hide-scrollbar gap-x-L flex w-full overflow-auto", className), children: Array.from({ length: 3 }).map((_, columnIndex) => /* @__PURE__ */ jsxs3(
    "div",
    {
      className: "flex w-full min-w-[450px] flex-1 flex-col justify-between",
      children: [
        /* @__PURE__ */ jsx3("div", { className: "bg-body-level-2 rounded-M my-L h-10 w-32 animate-pulse" }),
        /* @__PURE__ */ jsx3("div", { className: "flex h-full flex-col justify-around gap-6", children: Array.from({
          length: columnIndex === 0 ? 4 : columnIndex === 1 ? 2 : 1
        }).map((_2, matchIndex) => /* @__PURE__ */ jsx3(
          "div",
          {
            className: "bg-body-level-2 rounded-M h-52 w-full animate-pulse"
          },
          matchIndex
        )) })
      ]
    },
    columnIndex
  )) });
};
var BracketsLoader_default = BracketsLoader;

export {
  Brackets_default,
  BracketsV2_default,
  BracketsLoader_default
};
//# sourceMappingURL=chunk-HPDLTED6.mjs.map